<template>
    <div>
        <vx-card class="mb-3">
            <div class="vx-row mt-8">
                <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
                    <label class="text-sm opacity-100 text-bold">Manufacturing Date From</label>
                    <flat-pickr style="display: none" class="w-full" :config="{ dateFormat: 'd/m/Y' }"
                        v-model="filters['manufacture-from']" placeholder="Choose Date" />
                    <flat-pickr class="w-full" :config="{ dateFormat: 'd/m/Y' }" v-model="filters['manufacture-from']"
                        placeholder="Choose Date" />
                </div>
                <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
                    <label class="text-sm opacity-100 text-bold">Manufacturing Date To</label>
                    <flat-pickr style="display: none" class="w-full" :config="{ dateFormat: 'd/m/Y' }"
                        v-model="filters['manufacture-to']" placeholder="Choose Date" />
                    <flat-pickr class="w-full" :config="{ dateFormat: 'd/m/Y' }" v-model="filters['manufacture-to']"
                        placeholder="Choose Date" />
                </div>
                <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
                    <label class="text-sm opacity-100 text-bold">Expiry Date From</label>
                    <flat-pickr style="display: none" class="w-full" :config="{ dateFormat: 'd/m/Y' }"
                        v-model="filters['expiry-to']" placeholder="Choose Date" />
                    <flat-pickr class="w-full" :config="{ dateFormat: 'd/m/Y' }" v-model="filters['expiry-to']"
                        placeholder="Choose Date" />
                </div>
                <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
                    <label class="text-sm opacity-100 text-bold">Expiry Date To</label>
                    <flat-pickr style="display: none" class="w-full" :config="{ dateFormat: 'd/m/Y' }"
                        v-model="filters['expiry-to']" placeholder="Choose Date" />
                    <flat-pickr class="w-full" :config="{ dateFormat: 'd/m/Y' }" v-model="filters['expiry-to']"
                        placeholder="Choose Date" />
                </div>
            </div>
            <div class="vx-row mt-5">
                <div class="vx-col w-full ml-auto">
                    <vs-button class="float-right mr-4" size="small" color="danger" type="border" icon-pack="feather"
                        v-on:click="filters = {}">CLEAR</vs-button>
                </div>
            </div>
        </vx-card>
        <vx-card no-shadow>
            <div class="vx-row">
                <div class="vx-col w-full">
                    <vx-card no-shadow class="pt-2">
                        <div slot="no-body">
                            <vs-table id="sundry-item-list-table" :max-items="(meta.per_page) ? meta.per_page : 10"
                                :data="items" sort :sst="true" stripe
                                class="table-dark-inverted table-auto vs-con-loading__container">

                                <template slot="thead">
                                    <vs-th width="15%" class="text-sm">BATCH NO</vs-th>
                                    <vs-th width="10%" class="text-sm" sort-key="sundry_item_code">ITS PRODUCT
                                        CODE</vs-th>
                                    <vs-th width="10%" class="text-sm" sort-key="sundry_product_code">ITS PRODUCT
                                        NAME</vs-th>
                                    <vs-th width="5%" class="text-sm">SUPPLIER BATCH NUMBER</vs-th>
                                    <vs-th width="10%" class="text-sm">SHELF LOCATION</vs-th>
                                    <vs-th width="10%" class="text-sm">MANUFACTURE DATE</vs-th>
                                    <vs-th width="10%" class="text-sm">EXPIRATION DATE</vs-th>
                                    <vs-th width="10%" class="text-sm">QUANTITY (KG)</vs-th>
                                    <vs-th width="10%" class="text-sm">STOCK STATUS</vs-th>
                                    <vs-th width="10%" class="text-sm">ACTION</vs-th>
                                </template>

                                <template slot-scope="{data}">
                                    <vs-tr @click.native="onClickUpdateRmStock(data[indextr])" class="text-sm"
                                        style="cursor: pointer" :key="indextr" v-for="(tr, indextr) in data">


                                        <vs-td :data="data[indextr].batch_no">
                                            {{ data[indextr].batch_no }}
                                        </vs-td>

                                        <vs-td class="text-primary font-semibold"
                                            :data="data[indextr].company_product_code">
                                            {{ data[indextr].category }}-{{ data[indextr].company_product_code }}
                                        </vs-td>

                                        <vs-td :data="data[indextr].company_product_name">
                                            {{ data[indextr].company_product_name }}
                                        </vs-td>

                                        <vs-td :data="data[indextr].supplier_batch_no">
                                            {{ data[indextr].supplier_batch_no }}
                                        </vs-td>

                                        <vs-td>
                                            R {{ data[indextr].shelf_location_r || '-' }} | S {{
                        data[indextr].shelf_location_s || '-' }} | L {{
                        data[indextr].shelf_location_l || '-' }}
                                        </vs-td>


                                        <vs-td :data="data[indextr].manufacture_date">
                                            {{ data[indextr].manufacture_date }}
                                        </vs-td>

                                        <vs-td :data="data[indextr].expiration_date">
                                            {{ data[indextr].expiration_date }}
                                        </vs-td>

                                        <vs-td :data="data[indextr].available_quantity">
                                            {{ Number(data[indextr].available_quantity).toFixed(4) }}
                                        </vs-td>

                                        <vs-td :data="data[indextr].status">
                                            <vs-chip transparent :color="'dark'" style="border-radius: 0" class="w-32">
                                                {{ data[indextr].status | stock_status_format }} <span
                                                    class="text-danger ml-2 font-bold text-lg">{{
                        generateSuspendStatus(data[indextr].raw_material_status) }}</span>
                                            </vs-chip>
                                        </vs-td>


                                        <vs-td>
                                            <div class="vx-row">
                                                <vx-tooltip class="mr-2" text="Update rm stock" position="bottom">
                                                    <vs-button class="ml-3"
                                                        @click.stop="onClickUpdateRmStock(data[indextr])" size="small"
                                                        color="warning" type="border" icon-pack="feather"
                                                        icon="icon-edit"></vs-button>
                                                </vx-tooltip>
                                                <vx-tooltip v-if="data[indextr].status === 'On Hold'"
                                                    v-can="'create-edit-raw-material-orders-qc-test'"
                                                    class="flex justify-start mr-2" text="Return to available stock"
                                                    position="bottom">
                                                    <vs-button class="flex justify-end"
                                                        @click.stop="onClickReturnToStock(data[indextr])" size="small"
                                                        color="danger" type="border" icon-pack="feather"
                                                        icon="icon-rotate-cw"></vs-button>
                                                </vx-tooltip>
                                                <vx-tooltip v-can="'create-edit-raw-material-orders-qc-test'"
                                                    class="flex justify-start mr-2" text="View QC Test"
                                                    position="bottom">
                                                    <vs-button class="flex justify-end"
                                                        @click.stop="onClickUpdateQcTest(data[indextr].q_c_test.id, data[indextr].rm_id)"
                                                        size="small" color="primary" type="border" icon-pack="feather"
                                                        icon="icon-eye"></vs-button>
                                                </vx-tooltip>
                                            </div>
                                        </vs-td>

                                    </vs-tr>
                                </template>


                            </vs-table>

                            <vs-pagination v-on:changeMaxItems="changePage" :size-array="meta.total ? meta.total : 20"
                                :max-items="perPage" description-body="Rows per page" description-connector="of"
                                description-title="Records" description :description-items="descriptionItems"
                                :total="(meta.last_page) ? meta.last_page : 0" v-model="page" class="p-5">
                            </vs-pagination>


                        </div>
                    </vx-card>
                </div>
            </div>
        </vx-card>
        <update-rm-stock-pop-up v-on:refreshData="refreshData" ref="UpdateRmStockPopUp" />
        <update-qc-test-rm-order-item-pop-up ref="updateQcTestRmOrderItemPopUp" />
        <RmWasteSendBackToStockPopUp ref="rmWasteSendBackToStockPopUp" v-on:refreshData="refreshData" />
    </div>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const InventoryRepository = RepositoryFactory.get('inventory')
const ManufacturingRepository = RepositoryFactory.get('manufacturing')

import UpdateRmStockPopUp from "@/components/popups/manufacturing/raw-material-stock/UpdateRmStockPopUp";
import UpdateQcTestRmOrderItemPopUp from "@/components/popups/inventory/rm-orders/qc-tests/UpdateQcTestRmOrderItemPopUp";

import vSelect from 'vue-select'
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import Filter from '@/mixins/filter';
import { defaultPagination, perPageList } from "@/constants/config";
import flatPickr from "vue-flatpickr-component";
import 'flatpickr/dist/flatpickr.css'
import RmWasteSendBackToStockPopUp from '@/components/popups/inventory/stock/RmWasteSendBackToStockPopUp.vue';

function initialState() {
    return {
        open: false,
        items: [],
        filters: {},
        page: 1,
        total: 0,
        meta: {},
        sort: '',
        perPage: defaultPagination,
        descriptionItems: perPageList,
    }
}

export default {
    name: 'ViewRawMaterialStockPopUp',
    data() {
        return initialState()
    },
    methods: {
        closePopup() {
            this.open = false
        },
        async refreshData() {
            await this.fetchRmStockInventory()
        },
        async fetchRmStockInventory() {
            await this.$vs.loading({
                container: '#raw-material-stock-popup',
                scale: 0.45
            })
            try {
                const { data } = await ManufacturingRepository.getRawMaterialOnHoldStock(this.page, `${this.filterQuery}`, this.perPage, '')
                this.items = data.data
                this.meta = data.meta
            } catch (e) {
                this.showWarningMessage('Something went wrong. Please try again!')
            }
            this.$vs.loading.close('#raw-material-stock-popup > .con-vs-loading')
        },
        onClickUpdateRmStock(data) {
            this.$refs.UpdateRmStockPopUp.openPopup(data.id)
        },
        async onClickUpdateQcTest(test_id, rm_id) {
            await this.$refs.updateQcTestRmOrderItemPopUp.openPopup(test_id, rm_id)
        },
        async onClickReturnToStock(data) {
            this.$refs.rmWasteSendBackToStockPopUp.openPopup(data)
        },
        filterQueryUpdate() {
            this.fetchRmStockInventory()
        },

        handleChangePage(page) {
            this.page = page;
            this.fetchRmStockInventory()
        },
        handleSort(key, active) {
            if (key) {
                active = (active === 'desc') ? "-" : '';
                this.sort = active + key;
                this.fetchRmStockInventory()
            }

        },
        changePage(index) {
            this.perPage = this.descriptionItems[index]
        },
        toFixed(number) {
            return Math.floor(number * 10000) / 10000
            // return Number(number).toFixed(4)
        },
        onClickClose() {
            this.open = false
        },
        generateSuspendStatus(status) {
            if (status.includes('Suspended')) {
                return `S${status.charAt(status.length - 1)}`
            }
        }

    },

    components: {
        'v-select': vSelect,
        UpdateRmStockPopUp,
        UpdateQcTestRmOrderItemPopUp,
        flatPickr,
        RmWasteSendBackToStockPopUp,
    },
    mixins: [SuccessMessage, ErrorMessages, Filter],
    watch: {
        page() {
            this.fetchRmStockInventory()
        },
        perPage() {
            this.fetchRmStockInventory()
        },
    }
}
</script>

<style scoped>
.raw-material-stock-popup>>>.vs-popup {
    /*min-height: 50% !important;*/
    min-width: 70% !important;
}
</style>